import { Component, OnInit, OnDestroy, ElementRef, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OfferService } from '../services/offer/offer.service';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { Title, Meta } from '@angular/platform-browser';
import { appConstants } from 'src/app/shared/constants/app.constants';
import { Subject, Subscription, finalize, takeUntil } from 'rxjs';
import { DataTransferService } from 'src/app/shared/services/common/datatransfer.service';
import { ApiService } from 'src/app/config/api.service';
import { Offer } from 'src/app/shared/interfaces/offers.interface';
import { AdobeAnalyticsService } from "src/app/shared/services/common/adobeAnalytics.service";
import { CommonService } from 'src/app/shared/services/common/common.service';


@Component({
  selector: 'app-offer-list',
  templateUrl: './offer-list.component.html',
  styleUrls: ['./offer-list.component.scss']
})
export class OfferListComponent implements OnInit,OnDestroy {
  appConstants = appConstants;
  progress: boolean = true;
  code;
  categoryList = [];
  selectedCategory;
  selectedSubCategory;
  offerCategory;
  offerProgress = true;

  public offers: Offer[] = [];
  isMobile: boolean = false;
  isTablet: boolean = false;
  isDesktopDevice: boolean = false;
  categorySubscription: Subscription;
  private currentPage: number = 1;
  private perPage: number = 18;
  public preventCallingHandler: boolean = false;
  private destroy$: Subject<void> = new Subject<void>();
  public isCategoryChange: boolean = false;
  public categoryIcon: string = '';
  public categoryRefresh: boolean = false;

  @HostListener('unloaded')
  ngOnDestroy() {
    // this.dataTransferService.nextMessage(null)
    if(this.categorySubscription){
      this.categorySubscription.unsubscribe()
    }
    this.elementRef.nativeElement.remove();
    this.destroy$.next();
    this.destroy$.complete();
  }

  onResize() {
    if (window.innerWidth > 1024) {
      this.isDesktopDevice = true;
      this.isTablet = false;
      this.isMobile = false;
    }
    else if (window.innerWidth > 992) {
      this.isDesktopDevice = false;
      this.isTablet = true;
      this.isMobile = false;
    }
    else {
      this.isDesktopDevice = false;
      this.isTablet = false;
      this.isMobile = true;
    }
  }

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public authService: AuthService,
    private title:  Title,
    private dataTransferService: DataTransferService,
    private elementRef: ElementRef,
    private meta: Meta,
    private apiService: ApiService,
    public adobeAnalyticsService: AdobeAnalyticsService,
    public commonService: CommonService
  ) {
    window.scrollTo(0, 0);
    this.activatedRoute.paramMap.subscribe((paramMap) => {
      this.categoryRefresh = this.selectedCategory && this.selectedSubCategory && this.selectedSubCategory !== paramMap.get('sub_category') ? true : false;
      this.selectedCategory = paramMap.get('category');
      this.selectedSubCategory = paramMap.get('sub_category');
      const data = {
        pageName: `${this.selectedSubCategory} - category listing`,
        contentType: 'Category Page - Offer Listing'
      }
      this.categoryIcon = appConstants?.categories?.[this.selectedSubCategory]?.img;
      setTimeout(() => {
        this.dataTransferService.nextMerchantOfferData(data);
      }, 500);
      if (this.categoryRefresh) {
        this.currentPage = 1;
        this.offers = [];
        this.getMerchants();
      } else this.getCategories();
    });
    this.categoryIcon = appConstants?.categories?.[this.selectedSubCategory]?.img;
  }

  ngOnInit() {
    this.setPageTitleDescription();
    this.meta.addTag({ rel: 'canonical', href: appConstants.canonicalUrl + this.router.url });
    window.scrollTo(0,0);
    this.checkAuth();
    this.onResize();
    this.adobeAnalyticsService.loadDataLayerScript( {
      siteSection1: "Offer Page",
      siteSection2: "listing Page",
      pageName: "Offer listing Page", 
      contentType: "Offer Page - list Page",
      
    });    
    this.commonService.sendAnalyticsData('pageLoad' , 'pageInfo' , window['di']) ;
  }

  authenticated_user = false;
  checkAuth(){
    if (localStorage.getItem("currentUser")) {
      this.authenticated_user = true;
    }
    else{
      this.authenticated_user = false;
    }
  }

  private setPageTitleDescription() {
    switch (this.selectedSubCategory) {
      case 'productivity':
        this.title.setTitle("Exclusive offers & discounts on productivity tools for small businesses");
        this.meta.updateTag({ name: 'description', content: "Discover exclusive offers and discounts on productivity tools for small businesses at Easy Savings Specials. Save on software, services, and more to enhance your business efficiency." });
        break;
      case 'marketing':
        this.title.setTitle("Boost Small Business Marketing with Easy Savings Specials");
        this.meta.updateTag({ name: 'description', content: "Discover exclusive offers & discounts on marketing solutions with Mastercard Easy Savings Specials. Save on advertising, SEO & more for small businesses." });
        break;
      case 'hr-learning':
        this.title.setTitle("Enhance Small Business HR Learning with Easy Savings Specials");
        this.meta.updateTag({ name: 'description', content: "Empower your workforce with Mastercard Easy Savings Specials. Get exclusive offers & discounts on HR learning resources for small businesses." });
        break;
      case 'business-travel-entertainment':
        this.title.setTitle("Streamline Small Business Travel & Entertainment with Easy Savings Specials");
        this.meta.updateTag({ name: 'description', content: "Facilitate business travel & entertainment with Mastercard Easy Savings Specials. Enjoy exclusive offers & discounts for small businesses." });
        break;
      case 'customer-support':
        this.title.setTitle("Improve Small Business Customer Support with Easy Savings Specials");
        this.meta.updateTag({ name: 'description', content: "Enhance your customer support with Mastercard Easy Savings Specials. Get exclusive offers & discounts on customer support solutions for small businesses." });
        break;
      case 'security-compliance':
        this.title.setTitle("Enhance Small Business Security & Compliance with Easy Savings Specials");
        this.meta.updateTag({ name: 'description', content: "Safeguard your business with Mastercard Easy Savings Specials. Access exclusive offers & discounts on security & compliance for small businesses." });
        break;
      case 'online-readiness':
        this.title.setTitle("Boost Small Business Online Readiness with Easy Savings Specials");
        this.meta.updateTag({ name: 'description', content: "Strengthen your online presence with Mastercard Easy Savings Specials. Enjoy exclusive offers & discounts on online readiness for small businesses" });
        break;
      case 'local-offers':
        this.title.setTitle("Access Local Offers for Small Businesses with Easy Savings Specials");
        this.meta.updateTag({ name: 'description', content: "Support your community with Mastercard Easy Savings Specials. Get exclusive local offers & discounts for small businesses." });
        break;
      case 'workspaces-office-essentials':
        this.title.setTitle("Optimize Small Business Workspaces & Office Essentials with Easy Savings Specials");
        this.meta.updateTag({ name: 'description', content: "Create an efficient workspace with Mastercard Easy Savings Specials. Enjoy exclusive offers & discounts on workspaces & office essentials." });
        break;
      case 'logistics':
        this.title.setTitle("Streamline Small Business Logistics with Easy Savings Specials");
        this.meta.updateTag({ name: 'description', content: "Streamline your supply chain with Mastercard Easy Savings Specials. Access exclusive offers & discounts on logistics for small businesses." });
        break;
      case 'finance':
        this.title.setTitle("Manage Small Business Finance with Easy Savings Specials");
        this.meta.updateTag({ name: 'description', content: "Manage your finances effectively with Mastercard Easy Savings Specials. Get exclusive offers & discounts on small business finance solutions." });
        break;
      default:
        this.title.setTitle("Exclusive offers & discounts with Easy Savings Specials");
        this.meta.updateTag({ name: 'description', content: "Discover exclusive offers and discounts with Easy Savings Specials." });
        break;
    }
  }

  getMerchants() {
    this.categoryList.forEach(obj => {
      if (obj.attributes.code == this.selectedSubCategory) {
        this.selectedCategory = obj;
      }
    })

    if (this.selectedCategory) this.getOffers();
  }

  private getOffers(): void {
    this.offerProgress = true;
      const params = {
        per_page: this.perPage,
        page: this.currentPage,
        'categories': this.selectedCategory.attributes.code
      }

      this.apiService.getOffers(params)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => this.offerProgress = false)
      )
      .subscribe({
        next: (response: any) => {
          if(response.data < this.perPage) {
            this.preventCallingHandler = true;
          }
          this.offers = [
            ...this.offers,
            ...response?.data?.map((offer: Offer) => {
              return {
                ...offer,
                merchant: this.getMerchantDetails(offer, response?.included?.filter((info) => info?.type === 'merchant')),
                isDisabled: this.authService.isAuthenticated() ? !offer.attributes.claimable : false
              }
            })
          ];
        }
      });
  }

  getCategories() {
    if(!this.categorySubscription){
      this.categorySubscription = this.dataTransferService.sharedCategories.subscribe(res => {
        if(res && res.data){
          this.categoryList = res.data;
          this.getMerchants();
        }
      });
    }
  }


  moveUp() {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }

  private getMerchantDetails(offer, merchantData) {
    return merchantData.find((merchant) => merchant.id === offer.relationships.merchant.data.id);
  }

  onScroll() {
    if(!this.preventCallingHandler && !this.offerProgress) {
      this.currentPage += 1;
      this.getOffers();
    } 
  }

}
